module.exports = __webpack_public_path__ + "files/SPIADI2025 - Etude observationnelle HDM en Neonatologie.0ddc57371a50604022abd2316bb9c0bb.pdf";